import QBtn from 'quasar/src/components/btn/QBtn.js';
export default {
  props: {
    prependIcon: String
  },
  data () {
    return {
      prependIconColor: null
    }
  },
  computed: {
    computedPrependIcon () {
      return this.prependIcon
    }
  },
  mounted () {
    const input = this.$refs.input
    input.$watch('focused', this.renderPrependIconColor)
    input.$watch('hasValue', this.renderPrependIconColor)
    input.$watch('hasError', this.renderPrependIconColor)
    this.renderPrependIconColor()

    const inputGetInnerAppendNode = input.__getInnerAppendNode
    input.__getInnerAppendNode = function (h, key, content) {
      if (key === 'inner-clearable-append') {
        content[0].data.attrs.tabindex = -1
        // 参考quasar源码: QField.js
        // content = [h(QIcon, {
        //   staticClass: 'q-field__focusable-action',
        //   props: { tag: 'button', name: this.clearIcon || this.$q.iconSet.field.clear },
        //   attrs: { tabindex: -1, type: 'button' },
        //   on: this.clearableEvents
        // })]
      }
      return inputGetInnerAppendNode.call(this, h, key, content)
    }
  },
  methods: {
    renderPrependIconColor () {
      const input = this.$refs.input
      if (!input) return
      if (input.hasError) {
        this.prependIconColor = 'negative'
      } else if (input.focused) {
        this.prependIconColor = 'primary'
      } else if (!input.hasValue) {
        this.prependIconColor = null
      } else {
        this.prependIconColor = 'positive'
      }
    },
    slotPrependIcon (createElement) {
      return this.computedPrependIcon ? () => {
        return createElement(QBtn, {
          props: {
            glossy: false,
            round: true,
            dense: true,
            flat: true,
            icon: this.computedPrependIcon,
            color: this.prependIconColor,
            tabindex: -1,
            disable: this.disable || this.readonly
          },
          on: {
            click: () => {
              this.$refs.input.focus()
            }
          }
        })
      } : null
    }
  }
}
